import React from 'react';
import { CONVERSION_STATUSES, sourceLabel } from '../features/financialReportConversion';
import './FinancialAnalysisViews.css';

export const financialText = value => String(value ?? '').replace(/_/g, ' ');
export const retainedPeriods = report => (report?.review || report?.extraction)?.periods || [];

export function FinancialTabFrame({ title, description, report, actions, children, className = '', testId }) {
  const periods = retainedPeriods(report);
  const common = key => [...new Set(periods.map(period => period[key] || `${key} unconfirmed`))];
  const bases = common('basis');
  const units = [...new Set(periods.map(period => `${period.currency || 'Currency unconfirmed'} ${financialText(period.units) || 'units unconfirmed'}`))];
  return <section className={`fa-view ${className}`} data-testid={testId}>
    <header className="fa-heading"><div><h2>{title}</h2>{description && <p>{description}</p>}</div>{actions && <div className="fa-heading-actions">{actions}</div>}</header>
    {report && <div className="fa-context" aria-label="Saved report context">
      <span className="fa-status">{CONVERSION_STATUSES[report.status] || financialText(report.status) || 'Saved report'} · v{report.version}</span>
      <span>{bases.length === 1 ? financialText(bases[0]) : bases.length ? 'Reporting basis varies by period' : 'No retained reporting period'}</span>
      {units.length > 0 && <span>{units.length === 1 ? units[0] : 'Currency and units shown per period'}</span>}
      <span>{periods.map(period => period.label || period.periodEnd || period.id).join(' / ')}</span>
      {report.reviewDraft && <span className="fa-pending">Separate review draft pending</span>}
    </div>}
    {children}
  </section>;
}

export function FinancialNotice({ tone = 'info', children, className = '' }) {
  return <div className={`fa-notice fa-notice-${tone} ${className}`} role={tone === 'error' ? 'alert' : 'status'}><span className="fa-notice-icon" aria-hidden="true">{tone === 'warning' || tone === 'error' ? '△' : 'ⓘ'}</span><div>{children}</div></div>;
}

export function FinancialEvidence({ sources = [], onSource }) {
  const records = sources.filter(Boolean);
  if (!records.length) return <p className="fa-muted">No source reference was retained for this item.</p>;
  return <div className="fa-evidence">{records.map((source, index) => <div key={`${source.page || source.cell || source.fieldId || 'source'}:${index}`}>
    {onSource && (source.page || source.sheet || source.cell || source.fieldId) ? <button type="button" className="fa-link" onClick={() => onSource(source)}>{sourceLabel(source) || 'Open source context'}</button> : <span className="fa-muted">{sourceLabel(source) || 'Source location unavailable'}</span>}
    {source.quote && <blockquote>{source.quote}</blockquote>}
  </div>)}</div>;
}
